import { useMemo } from 'react';

import { useDevicesSelection } from '../../store/devices/useDevices.ts';

import { theme } from '../../theme/theme';

import { Icon } from '../common/Icon';
import { SpinnerLoading } from '../common/SpinnerLoading';
import { IndicatorCapability } from './IndicatorCapability';

import { iconWarning } from '../../theme/icons/interface/warning/warning';

export function Indicator({ device, tileSize }) {
  if (device == null) {
    return null;
  }

  if (device.ready === null) {
    return <SpinnerLoading size={24} />;
  }

  if (device.available === false || device.ready === false) {
    return (
      <Icon
        display="block"
        url={iconWarning}
        color={theme.color.error}
        size={theme.icon.size_default}
      />
    );
  }

  if (device.driverId === 'homey:virtualdrivergroup:driver') {
    return <IndicatorGroup device={device} tileSize={tileSize} />;
  }

  return <IndicatorCapability device={device} tileSize={tileSize} />;
}

function IndicatorGroup(props) {
  const deviceIds = props.device.settings.deviceIds ?? [];
  const selection = useDevicesSelection({ deviceIds });

  const isSomeDeviceUnavailable = useMemo(() => {
    return Object.values(selection).some((device) => {
      // If the device was not found ignore it for the available status.
      if (device == null) {
        return false;
      }

      return device.available === false;
    });
  }, [selection]);

  if (isSomeDeviceUnavailable) {
    return (
      <Icon
        display="block"
        url={iconWarning}
        color={theme.color.warning}
        size={theme.icon.size_default}
      />
    );
  }

  return <IndicatorCapability device={props.device} tileSize={props.tileSize} />;
}
